import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getAnalytics } from 'firebase/analytics';

// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyATmxWA2GlDdSrK0Yh37iA03JBggLq7ZjQ",
  authDomain: "novonix-labs-development.firebaseapp.com",
  projectId: "novonix-labs-development",
  storageBucket: "novonix-labs-development.firebasestorage.app",
  messagingSenderId: "319481659892",
  appId: "1:319481659892:web:d561a32753eb1663cd79a1",
  measurementId: "G-T7814RVMJH"
};



const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);
const analytics = getAnalytics(app);

export { auth, db, analytics };
